import { useParams } from "react-router-dom";
import { TitleWithDivider } from "@common/TitleWithDivider";
import UserInformation from "@components/Forms/UserProfileForm";
import { error_message } from "@constants/Errors";
import pageHeaders from "@constants/PageHeaders";
import { pageTitles } from "@constants/PageTitles";
import PageTitle from "@common/PageTitle";

const ViewCurrentUserPage: React.FC = () => {
  const { id } = useParams<{ id: string }>();

  return (
    <>
      <div>
        <PageTitle
          title={
            id === "myPage" ? pageTitles.USER.admin_view : pageTitles.USER.edit
          }
        />
        <TitleWithDivider
          titleText={
            id == "myPage" ? pageHeaders.USER.admin_view : pageHeaders.USER.edit
          }
          useDivider={true}
        />
        <UserInformation
          id={id != null ? id : error_message.generic.unknown}
        ></UserInformation>
      </div>
    </>
  );
};

export default ViewCurrentUserPage;
